import { Controller } from "stimulus";
import { openModal } from "../modal/utils";

export default class extends Controller {
  static targets = ["experience", "gridWrap", "hiddenWrap"];

  connect = () => {
    // by storing experiences here we maintain the original order
    this.experiences = this.experienceTargets;
    this.filterByString(`#`);
  };

  // Sub Nav List Item Click Handler.
  filter = e => {
    e.stopPropagation();
    // Strip the /'s from the category slug.
    const filter = e.currentTarget.dataset.filter.replace(/\//g, ``);
    // Pass the cat slug to our filter function.
    this.filterByString(filter);
  };

  // Filter Handler
  filterByString = filter => {
    // If the category URL is "#", we've clicked "All" and should show all results.
    if (filter === `#`) {
      this.experiences.map(exp => {
        if (exp.dataset.category) {
          // Reason: Intentional: The purpose of this map function is to modify the param.
          // eslint-disable-next-line no-param-reassign
          exp.querySelector(".subtitle").innerText = exp.dataset.category;
        }
        this.gridWrapTarget.appendChild(exp);
        return true;
      });
    } else {
      // If we're filtering, only show matches.
      this.experiences.map(exp => {
        if (exp.dataset.filters.includes(filter)) {
          // Reason: Intentional: The purpose of this map function is to modify the param.
          // eslint-disable-next-line no-param-reassign
          exp.querySelector(".subtitle").innerText = filter;
          this.gridWrapTarget.appendChild(exp);
        } else {
          this.hiddenWrapTarget.appendChild(exp);
        }
      });
    }

    // Delete old rows, we'll rebuild them if we need them.
    Array.from(this.gridWrapTarget.querySelectorAll(".row")).map(row =>
      row.remove()
    );

    // Grid contains some tiles, let's 2-3 it.
    if (this.gridWrapTarget.querySelector(".experience")) {
      // While there still are some not in rows:
      let rowCount = 0;
      while (document.querySelector(".grid-wrap > .experience")) {
        const newRow = document.createElement("div");
        newRow.classList.add("row");
        this.element.querySelector(".grid-wrap").appendChild(newRow);

        for (let i = 0; i < (rowCount % 2) + 2; i += 1) {
          const newRowEl = this.element.querySelector(
            ".grid-wrap > .row:last-of-type"
          );
          const expToMove = this.element.querySelector(
            ".grid-wrap > .experience"
          );
          if (newRowEl && expToMove) newRowEl.appendChild(expToMove);
        }
        rowCount += 1;
      }
    }
  };

  // Show experience overlay on "Read More" click:
  showOverlay = e => {
    // Get '.experience' wrapper
    const exp = e.currentTarget.closest(".experience");
    // Get overlay's DOM element
    const overlay = document.querySelector(
      `.experience-overlay-${exp.dataset.id}`
    );
    // Open it up!
    openModal(overlay);
  };
}
